/**
 * Log Deal manifest — `log-deal` action.
 *
 * Walks any source → company. Opens the existing CreateDealModal with the
 * resolved company prefilled (company_id initial value, company name in title).
 *
 * For companies: same-entity, resolver bypassed — falls through to the
 * openCreateDealModal handler which reads id/name from the row directly.
 * For contacts: walks contact → company (one hop, auto-resolved).
 */

import { MODAL_IDS } from "@wtc/ui";

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "log-deal",
  label: "Log a deal",
  primaryEntity: "company",
  requires: {
    entity: "company",
    requiredFields: [],
  },
  mode: "client-redirect",
  clientRun: (resolved, hooks) => {
    hooks.openModal(MODAL_IDS.deals.create, {
      companyId: resolved.targetIds[0],
      sourceEntity: resolved.sourceEntity,
      sourceId: resolved.sourceId,
    });
  },
});
